export default __webpack_public_path__ + "static/media/background2.7e90c6c4.svg";